import { useId, type ReactNode } from "react";

import type { KonfigurationsFeld } from "@repo/shared";

/** Zahl deutsch, höchstens zwei Nachkommastellen: 166.67 → "166,67". */
export function zahlText(wert: number): string {
  return wert.toLocaleString("de-DE", { maximumFractionDigits: 2 });
}

/**
 * Feldname mit Zusatz und Pflichtkennzeichen. `verborgen` blendet ihn nur
 * optisch aus – etwa wenn der Schritttitel ihn schon nennt.
 */
export function Beschriftung({
  feld,
  zusatz,
  verborgen,
  id,
}: {
  feld: KonfigurationsFeld;
  zusatz?: string;
  verborgen?: boolean;
  id?: string;
}) {
  return (
    <span id={id} className={verborgen ? "konfi-unsichtbar" : undefined}>
      {feld.label}
      {zusatz}
      {feld.zustand.pflicht && <span className="pflicht"> *</span>}
    </span>
  );
}

/** Fehler und Hinweis unter einem Feld. */
export function FeldFuss({ feld }: { feld: KonfigurationsFeld }) {
  return (
    <>
      {feld.zustand.fehler && <small className="error">{feld.zustand.fehler}</small>}
      {feld.hinweis && <small className="muted">{feld.hinweis}</small>}
    </>
  );
}

/**
 * Rahmen für Felder aus mehreren Bedienelementen (Karten, Knöpfe, Tabelle):
 * Name oben, Fehler und Hinweis unten – wie bei jedem anderen Feld.
 */
export function FeldRahmen({
  feld,
  beschriftungVerbergen,
  children,
}: {
  feld: KonfigurationsFeld;
  beschriftungVerbergen?: boolean;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <div className="field konfi-feld" role="group" aria-labelledby={id}>
      <Beschriftung feld={feld} verborgen={beschriftungVerbergen} id={id} />
      {children}
      <FeldFuss feld={feld} />
    </div>
  );
}
